import React, { FC } from 'react';
import { ModalContext } from '../ModalContext';
import { GenericModalProps } from './types';
import { Modal, Layout, Callout, Button } from '../../core/';
import { ModalSize } from '../../core/components/Modal/types';
import { i18n } from '../../i18n/translate';

export const GenericModal: FC<GenericModalProps> = props => {
  const {
    canClose,
    children,
    footerCloseButton,
    id,
    isCentered,
    message,
    messageType,
    onClose,
    onExitComplete,
    saveButtonConfig,
    show = true,
    showAlert,
    size = 'lg',
    stickyFooter,
    title,
  } = props;

  const modalFooter = (
    <>
      {footerCloseButton && (
        <Button
          id={footerCloseButton.id || 'generic-modal-cancel-button'}
          onClick={onClose}
          variant={footerCloseButton.variant || 'secondary'}
          data-action={footerCloseButton.dataAction || 'cancel-button'}
          {...footerCloseButton.attributes}
        >
          {footerCloseButton.label || i18n.t('Cancel')}
        </Button>
      )}
      {saveButtonConfig && (
        <Button
          isDisabled={saveButtonConfig.disabled}
          id={saveButtonConfig.id || 'generic-modal-save-button'}
          onClick={saveButtonConfig.onClick}
          variant={saveButtonConfig.variant}
          data-action={saveButtonConfig.dataAction || 'save-button'}
          {...saveButtonConfig.attributes}
        >
          {saveButtonConfig.label || i18n.t('Save')}
        </Button>
      )}
    </>
  );

  return (
    <ModalContext.Provider value={true}>
      <Modal
        footer={modalFooter}
        header={title}
        id={id}
        isCentered={isCentered || stickyFooter}
        isOpen={show}
        modalType="modal"
        onClose={onClose}
        onExitComplete={onExitComplete}
        showCloseButton={canClose}
        size={size as ModalSize}
      >
        {showAlert && (
          <Layout mb={4}>
            <Callout description={message!} showIcon={false} title="" variant={messageType} />
          </Layout>
        )}
        {children}
      </Modal>
    </ModalContext.Provider>
  );
};
